<template>
  <div class="club-avatar" :class="[size]">
    <img
      class="club-avatar__img"
      :src="src"
      alt=""
      :class="{ border: isCardUser }"
    />

    <img
      v-if="isCardUser"
      class="club-avatar__tag"
      src="../../assets/image/club/avatar-tag.png"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: "ClubAvatar",
  props: {
    src: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: () => "default",
    },
    isCardUser: {
      type: Boolean,
    },
  },
};
</script>

<style lang="less" scoped>
.club-avatar {
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-self: flex-start;

  &__img {
    object-fit: cover;
    border-radius: 50%;

    &.border {
      border: 1.5px solid rgba(35, 234, 171, 0.7);
    }
  }

  &__tag {
    position: absolute;
    right: -1px;
    bottom: -1px;
    z-index: 1;
  }

  &.default {
    .club-avatar__img {
      width: 45px;
      height: 45px;
    }
    .club-avatar__tag {
      width: 17px;
      height: 17px;
    }
  }

  &.size35 {
    .club-avatar__img {
      width: 35px;
      height: 35px;
    }
    .club-avatar__tag {
      width: 16px;
      height: 16px;
    }
  }

  &.size33 {
    .club-avatar__img {
      width: 33px;
      height: 33px;
    }
    .club-avatar__tag {
      width: 16px;
      height: 16px;
    }
  }

  &.size22 {
    .club-avatar__img {
      width: 22px;
      height: 22px;
    }
    .club-avatar__tag {
      width: 11px;
      height: 11px;
    }
  }

  &.size18 {
    .club-avatar__img {
      width: 18px;
      height: 18px;
    }
    .club-avatar__tag {
      width: 9px;
      height: 9px;
      right: 1px;
      bottom: 1px;
    }
  }
}
</style>
